module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hrms-staappr', {
    attrs: {
      "staappr": _vm.detail.staappr,
      "nowLang": _vm.nowLang,
      "currentDtereq": _vm.setDateOutput(_vm.currentDtereq),
      "currentNumseq": _vm.currentNumseq,
      "currentCodempid": _vm.currentCodempid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-topic border-color-skin"
  }, [_c('i', {
    staticClass: "fa fa-envelope margin-r-5 color-skin"
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin"
  }, [_vm._v(_vm._s(_vm.descCodapp))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon align-center disabled-icon"
  }, [_vm._v("\n                                  " + _vm._s(_vm.detail.codleave) + "\n                              ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "id": "desc_codleave",
      "name": "desc_codleave",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.desc_codleave
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "A",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "A")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "A")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES6MEC2']['200']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "M",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "M")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "M")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES6MEC2']['210']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "E",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "E")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "E")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES6MEC2']['220']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "H",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "H")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "H")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES6MEC2']['230']) + "\n                                      ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['40']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "id": "dtestrt",
      "name": "dtestrt",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.dtestrt)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['50']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "id": "dteend",
      "name": "dteend",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.dteend)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['80']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "id": "timstrt_display",
      "name": "timstrt_display",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.timstrt
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['90']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "id": "timend_display",
      "name": "timend_display",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.timend
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['70']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "deslereq",
      "id": "deslereq",
      "maxlength": "600",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.detail.deslereq))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6MEC2']['60']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desreq),
      expression: "detail.desreq"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:200'),
      expression: "'required|max:200'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "desreq",
      "maxlength": "200",
      "data-vv-name": "desreq",
      "disabled": !_vm.validateStaappr,
      "has-error": _vm.errors.has('desreq')
    },
    domProps: {
      "value": (_vm.detail.desreq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desreq", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desreq')),
      expression: "errors.has('desreq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desreq')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer align-center border-color-skin"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fc06a61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6me/detail.vue
// module id = 3667
// module chunks = 1